import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

// I can make it standalone
// but since we use modules, I will not make it standalone. Invistigate
@Component({
  selector: 'conn-version-footer',
  templateUrl: './version-footer.component.html',
  styleUrl: './version-footer.component.css',
  standalone: false,
})
export class VersionFooterComponent {
  //is there a css style for vsp-foot-item? I could not find it
  // does it make to also create header component as app component uses too much html?

  @Input() isEyefinityApp = false;
  today: Date = new Date();
  version = environment?.version;
}
